import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";

const WarehouseStockInfoReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const redirectBasedOnUseCase = () => {
    const useCase = localStorage.getItem("useCase");

    switch (useCase) {
      case "Procurement":
        navigate("/fmnmis");
        break;

      case "Seed Production":
        navigate("/SeedMIS");
        break;

      case "Agri Promoter":
        navigate("/agrimis");
        break;

      case "Research Program":
        navigate("/researchProgramMIS");
        break;

      default:
        navigate("/fmnmis");
        break;
    }
  };

  const handleButtonClick = () => {
    redirectBasedOnUseCase();
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [warehosuedata, setWarehosuedata] = useState([]);
  const [warehouseId, setWarehouseId] = useState();

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getTemplateData } = useHttp();

  const fillTemplateData = (warehouseId) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    // if (employeeId > 0) {
    //   urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    // }

    if (warehouseId > 0) {
      urlfilter = urlfilter + `&warehouseId=${warehouseId}`;
    }

    // if (regionId > 0) {
    //   urlfilter = urlfilter + `&regionId=${regionId}`;
    // }
    // if (farmerNo != "") {
    //   urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    // }

    var url = `/api/warehouseStockEntryreport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getTemplateData(
      {
        url: url,
      },
      (data) => {
        console.log("reportdata", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    fillTemplateData(0, 0, "");
  }, [getTemplateData]);

  const fieldsToExport = [
    "createdDate",
    "productName",
    "productTypeName",
    "areaInHa",
    "unitAbbreviation",
    "pricePerUnit",
    "currentQuantity",
    "currentAmount",
    "quantity",
    "qtyPerHa",
    "value",
    "warehouseName",
    "vendorName",
    "seasonName",
    "templateName",
    "createdDate",
  ];

  const customHeaders = [
    "Date",
    "Product",
    "Product Sub Type",
    "Area(Ha)",
    "Unit",
    "Unit Cost",
    "Current Quantity",
    "Current Cost",
    "Quantity",
    "Quantity/ha",
    "Total Cost/Ha",
    "Warehouse Name",
    "Vendor",
    "Season",
    "Input Template Used",
    "Created Date",
  ];

  const handleExportExcel = () => {
    const filename = "WarehouseStockInfoReport.xlsx";
    //console.log(fieldsToExport, customHeaders);
    const processedData = data.map((item) => ({
      ...item,
      createdDate: item.createdDate
        ? new Date(item.createdDate).toLocaleDateString("en-GB")
        : "",
    }));

    convertToExcel(processedData, fieldsToExport, filename, customHeaders);
  };

  const { sendRequest: getWarehouseData } = useHttp();

  const getWarehouseDetail = () => {
    getWarehouseData(
      {
        // url: "/api/warehouses/",
        url: `/api/warehouses/?orgId=${localStorage.getItem(
          "orgId"
        )}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          setWarehosuedata(res);
        }
      }
    );
  };

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  //   const { sendRequest: getEmp } = useHttp();

  //   const EmployeeDetail = (region) => {
  //     var urlfilter = "";

  //     if (region > 0) {
  //       urlfilter = urlfilter + `&regionId=${region}`;
  //     }
  //     getEmp(
  //       {
  //         url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
  //           "empId"
  //         )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
  //       },
  //       (data) => {
  //         console.log("emp", data);
  //         var emplist = data;

  //         setEmployeeData(emplist);
  //         setEmployeeAllData(emplist);
  //       }
  //     );
  //   };

  //   useEffect(() => {
  //     EmployeeDetail(0);
  //   }, [getEmp]);

  //   const { sendRequest: getRegion } = useHttp();
  //   useEffect(() => {
  //     getRegion(
  //       {
  //         url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
  //           "orgId"
  //         )}`,
  //       },
  //       (data) => {
  //         //console.log("region", data);

  //         setRegionData(data);
  //       }
  //     );
  //   }, [getRegion]);

  // const { sendRequest: getFarmerNumber } = useHttp();
  // useEffect(() => {
  //   getFarmerNumber(
  //     {
  //       url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
  //         "orgId"
  //       )}&fieldExecutiveId=${employeeId}`,
  //     },
  //     (data) => {
  //       console.log("farmerNumberList", data);

  //       setFarmerData(data);
  //     }
  //   );
  // }, [employeeId]);

  // const handleSearch = (value) => {
  //   setFarmerNumber(value);
  // };

  // const options = farmerData&&farmerData.map(item => ({ value: item.identificationNo }));

  // const filteredOptions =
  //   farmerData &&
  //   farmerData
  //     .filter((item) => item.farmerNo.includes(farmerNumber))
  //     .map((item) => ({ value: item.farmerNo }));

  //console.log(filteredOptions);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title">Warehouse Stock Info Report</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Warehouse</label>
                  <select
                    id="warehouseId"
                    className="form-control"
                    ref={(el) => (frmRef.current["warehouseId"] = el)}
                    value={warehouseId}
                    required
                    onChange={(e) => {
                      setWarehouseId(e.target.value);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {warehosuedata &&
                      warehosuedata.map((x) => (
                        <option key={x.id} warehouse-id={x.id} value={x.id}>
                          {x.name} {}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              {/* <div className="col-md-3">
                <div className="form-group">
                  <label>Destination Warehouse</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div> */}
              {/* <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div> */}
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        min={selectedFromDate}
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="row">
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillTemplateData(warehouseId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Sr.No</th>
                          <th>Date</th>
                          <th>Product</th>
                          <th>Product Sub Type</th>
                          <th>Area(Ha)</th>
                          <th>Unit</th>
                          <th>Unit Cost</th>
                          <th>Current Quantity</th>
                          <th>Current Cost</th>
                          <th>Quantity</th>
                          <th>Quantity/Ha</th>
                          <th>Total Cost/Ha</th>
                          <th>Warehouse Name</th>
                          <th>Vendor</th>
                          <th>Season</th>
                          <th>Input Template Used</th>
                          <th>Created Date</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{i + 1}</td>
                                <td>
                                  {new Date(
                                    itm.createdDate
                                  ).toLocaleDateString()}
                                </td>
                                <td>{itm.productName}</td>
                                <td>{itm.productTypeName}</td>
                                <td>{itm.areaInHa}</td>
                                <td>{itm.unitAbbreviation}</td>
                                <td>{itm.pricePerUnit}</td>
                                <td>{itm.currentQuantity}</td>
                                <td>{itm.currentAmount}</td>
                                <td>{itm.quantity}</td>
                                <td>{itm.qtyPerHa}</td>
                                <td>{itm.value}</td>
                                <td>{itm.warehouseName}</td>
                                <td>{itm.vendorName}</td>
                                <td>{itm.seasonName}</td>
                                <td>{itm.templateName}</td>
                                <td>
                                  {new Date(
                                    itm.createdDate
                                  ).toLocaleDateString()}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default WarehouseStockInfoReport;
